import { type ChangeEvent, useCallback } from 'react'
import { Select } from '@/components/inputs/Select'
import { COUNTRIES } from '@/assets/data/countries'

export interface CountryInputProps {
  value: string
  onChange: (countryCode: string) => unknown
  isDisabled?: boolean
  testId?: string
}

/**
 * Selects a country.
 */
export function CountryInput({
  value,
  onChange,
  isDisabled,
  testId,
}: CountryInputProps) {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      onChange(COUNTRIES[Number(e.target.value)][0])
    },
    [onChange],
  )
  return (
    <Select
      isDisabled={isDisabled}
      items={COUNTRIES}
      value={value}
      onChange={handleChange}
      data-test={testId}
    />
  )
}
